module.exports = __webpack_public_path__ + "static/media/ParentsGuidePageRU.c2071b55.pdf";